import React from "react";
import PropTypes from "prop-types";
import "./LabelChip.css"; // Import the CSS styles for chips

const LabelChip = ({ type, name, state }) => {
  // Determine the appropriate CSS class based on state or type/name
  const getLabelClass = () => {
    if (state === "positive") return "chip-positive";
    if (state === "negative") return "chip-negative";
    if (state === "mixed") return "chip-mixed";
    if (state === "neutral") return "chip-neutral";

    // If state is "active" or undefined, fallback to type and name checks
    if (type === "Gender") {
      if (name === "Woman") return "chip-gender-woman";
      if (name === "Man") return "chip-gender-man";
      if (name === "Unknown Gender") return "chip-gender-unknown";
      return "chip-active";
    }

    if (type === "Age") {
      if (name === "<25") return "chip-age-under-25";
      if (name === "25-34") return "chip-age-25-34";
      if (name === "35-44") return "chip-age-35-44";
      if (name === "45-54") return "chip-age-45-54";
      if (name === "55+") return "chip-age-55-plus";
      if (name === "Unknown Age") return "chip-age-unknown";
      return "chip-active";
    }

    return "chip-active"; // Default class if no conditions match
  };

  return <span className={`label-chip ${getLabelClass()}`}>{name}</span>;
};

LabelChip.propTypes = {
  type: PropTypes.string.isRequired, // The type of label, e.g., "Gender", "Age"
  name: PropTypes.string.isRequired, // The name of the label, e.g., "Woman", "<25"
  state: PropTypes.string, // Optional: The state of the label, e.g., "positive", "negative", "mixed"
};

LabelChip.defaultProps = {
  state: "active", // Default to "active" if no state is provided
};

export default LabelChip;
